import Button from 'components/Button';
import Icon from 'components/Icon';
import {FC, useEffect} from 'react';
import {c, jt, t} from 'ttag';
import {setUrl} from 'utils/request';

type EmailSentSuccessProps = {
    code: string;
    email: string;
};

const EmailSentSuccess: FC<EmailSentSuccessProps> = ({code, email}) => {
    const boldEmail = <b>{email}</b>;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <h1 className="mt-2 flex">
                <Icon className="my-0.5 mr-2 text-green-500" icon="message" />
                {t`Please check your email`}
            </h1>
            <div className="pb-4 pt-2 sm:ml-8">
                <p className="pb-4">
                    {jt`We sent a verification link to ${boldEmail}. Please access that link to complete the registration.`}
                </p>
                <p className="mb-2 text-sm text-grey-600">
                    {t`Verification links expire in 48 hours.`}
                </p>
                <p className="mb-2 text-sm text-grey-600">
                    {c('dx-helper').t`Didn't get an email?`}
                </p>
                <ul className="text-sm text-grey-600">
                    <li>{t`Confirm you typed your email address correctly.`}</li>
                    <li>{t`Check your email account's spam folder and that your email server is not blocking emails from the makeleaps.com domain.`}</li>
                    <li>{t`The settings of the requesting organization may have changed since initially requesting your email address. Please contact the requesting organization.`}</li>
                </ul>
            </div>
            <div className="mt-4 flex flex-row justify-end gap-4 pb-4">
                <Button
                    aria-label="try-again"
                    className="border-transparent text-left text-green-700"
                    kind="custom"
                    onClick={() => setUrl(`/dx/${code}`)}
                >
                    {t`Try Again`}
                </Button>
            </div>
        </div>
    );
};

export default EmailSentSuccess;
